export default __webpack_public_path__ + "static/media/reject-payment.8ec880b2.svg";